import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import ko from './locales/ko.json'
import en from './locales/en.json'

/**
 * Resolve the initial language. Telegram exposes `language_code` on the user
 * object; we prefer that over the browser detector when present.
 */
function resolveInitialLanguage(): string | undefined {
  const tg = typeof window !== 'undefined' ? window.Telegram?.WebApp : undefined
  const code = tg?.initDataUnsafe?.user?.language_code
  if (!code) return undefined
  return code.toLowerCase().startsWith('ko') ? 'ko' : code
}

const initialLng = resolveInitialLanguage()

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ko: { translation: ko },
      en: { translation: en },
    },
    fallbackLng: 'en',
    ...(initialLng ? { lng: initialLng } : {}),
    supportedLngs: ['ko', 'en'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['querystring', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lng',
    },
  })

export default i18n
